module.exports = __webpack_public_path__ + "img/LCP 1.abf2a793.png";